import React, { useState, useEffect } from 'react';
import '../styles/spot.css';

function Spot() {
  const [tradingPairs, setTradingPairs] = useState([]);
  const [spotAssets, setSpotAssets] = useState([]);
  const [spotHistory, setSpotHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('SPOT MARKET');

  useEffect(() => {
    const fetchSpotData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Fetch trading pairs data from CoinGecko
        const response = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=cardano,avalanche-2,bitcoin,dogecoin&order=market_cap_desc&per_page=4&page=1'
        );

        if (!response.ok) throw new Error(`Failed to fetch data: ${response.status}`);
        const data = await response.json();

        const formattedData = data.map(coin => ({
          pair: `${coin.symbol?.toUpperCase() || 'N/A'}USD`,
          icon: coin.image || '/icons/default.png',
          lastPrice: coin.current_price != null ? coin.current_price.toFixed(5) : "0.00000",
          change: coin.price_change_percentage_24h != null ? coin.price_change_percentage_24h.toFixed(2) : "0.00",
        }));

        setTradingPairs(formattedData);

        // Mock Spot Assets data
        setSpotAssets([
          { symbol: 'BTC', quantity: 0.5 },
          { symbol: 'ETH', quantity: 2.3 },
          { symbol: 'ADA', quantity: 100 },
          { symbol: 'DOGE', quantity: 5000 },
        ]);

        // Mock Spot History data
        setSpotHistory([
          { date: '2023-10-01', action: 'Buy', symbol: 'BTC', quantity: 0.1, price: 25000 },
          { date: '2023-10-02', action: 'Sell', symbol: 'ETH', quantity: 1, price: 1500 },
          { date: '2023-10-03', action: 'Buy', symbol: 'ADA', quantity: 100, price: 0.25 },
          { date: '2023-10-04', action: 'Sell', symbol: 'DOGE', quantity: 5000, price: 0.07 },
        ]);

      } catch (err) {
        console.error('Fetch error:', err.message);
        setError('Failed to load data. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSpotData();
    const interval = setInterval(fetchSpotData, 60000); // Refresh every 60s
    return () => clearInterval(interval);
  }, []);

  if (isLoading) return <div className="spot-page">Loading...</div>;
  if (error) return <div className="spot-page">Error: {error}</div>;

  return (
    <div className="spot-page">
      <div className="spot-content">
        {/* Tabs */}
        <div className="spot-tabs">
          {['SPOT MARKET', 'SPOT ASSETS', 'SPOT HISTORY'].map(tab => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* SPOT MARKET */}
        {activeTab === 'SPOT MARKET' && (
          <div className="spot-table">
            <div className="table-header">
              <span>Pair</span>
              <span>Last Price</span>
              <span>Change</span>
              <span>Action</span>
            </div>
            {tradingPairs.map((pair, index) => (
              <div key={index} className="table-row">
                <div className="pair-info">
                  <img
                    src={pair.icon}
                    alt={pair.pair}
                    className="pair-icon"
                    onError={(e) => (e.target.src = '/icons/default.png')}
                  />
                  <span>{pair.pair}</span>
                </div>
                <div className="last-price">${pair.lastPrice}</div>
                <div className={`change ${parseFloat(pair.change) >= 0 ? 'positive' : 'negative'}`}>
                  {pair.change}%
                </div>
                <button className="trade-btn">TRADE</button>
              </div>
            ))}
          </div>
        )}

        {/* SPOT ASSETS */}
        {activeTab === 'SPOT ASSETS' && (
          <div className="spot-table">
            <div className="table-header">
              <span>Symbol</span>
              <span>Quantity</span>
            </div>
            {spotAssets.map((asset, index) => (
              <div key={index} className="table-row">
                <div className="pair-info">{asset.symbol}</div>
                <div className="last-price">{asset.quantity}</div>
              </div>
            ))}
          </div>
        )}

        {/* SPOT HISTORY */}
        {activeTab === 'SPOT HISTORY' && (
          <div className="spot-table">
            <div className="table-header">
              <span>Date</span>
              <span>Action</span>
              <span>Symbol</span>
              <span>Quantity</span>
              <span>Price</span>
            </div>
            {spotHistory.map((history, index) => (
              <div key={index} className="table-row">
                <div className="last-price">{history.date}</div>
                <div className="last-price">{history.action}</div>
                <div className="last-price">{history.symbol}</div>
                <div className="last-price">{history.quantity}</div>
                <div className="last-price">${history.price}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Spot;
